<template>
  <div :class="$style.profitSharing">
    <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
      <template v-slot:title>
        <span>
          業績分潤
        </span>
      </template>
      <div v-for="(commissionItem, commissionIndex) in commissionPersonList" :key="commissionIndex" :class="$style.commissionPersonDisplay">
        <template v-if="commissionItem.name.length > 0">
          <div class="personPrice">
            <p
              >分潤人員：<span class="mainText">{{ commissionItem.name }}</span></p
            >
            <p
              >分潤金額：<span class="mainText">NT${{ commissionItem.price }}</span></p
            >
          </div>
          <div class="trash">
            <span @click="handleRemove(commissionItem)"> <BaseIcon name="trash-alt" :class="$style.mainColor" /><span style="color: 'black'">移除人員</span> </span>
          </div>
        </template>
      </div>
      <div class="addBtn" @click="openAddProfileSharingDialog">
        <p :class="$style.mainColor">＋新增業績分潤人員</p>
      </div>
    </BaseCollapse>
    <el-dialog v-if="addProfileSharingDialog" :visible="addProfileSharingDialog" title="新增業績分潤人員" top="0" append-to-body :destroy-on-close="true" @close="handleClose">
      <el-form ref="form" :model="submitData" class="el-form-item--normal-margin">
        <el-form-item label="選擇人員隸屬分店">
          <el-select v-model="submitData.product_id" class="is-border">
            <el-option v-for="store in productList" :key="store.id" :value="store.id" :label="store.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="選擇人員">
          <el-select v-model="submitData.schedule_item_id" class="is-border">
            <el-option v-for="scheduleItem in filterScheduleItemList" :key="scheduleItem.id" :value="scheduleItem.id" :label="scheduleItem.name"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="服務抽成設定">
          <el-select v-model="submitData.commission_type" class="is-border">
            <el-option value="fixed" label="依固定金額"></el-option>
            <el-option value="%" label="依比例"></el-option>
          </el-select>
        </el-form-item>
        <template v-if="submitData.commission_type === 'fixed'">
          <el-form-item label="分潤訂單金額" :class="$style.profitSlider">
            <el-input v-model="submitData.commission_value" type="number" :min="0" :max="orderInfo.priceTotal" @input="handleInput" />
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="分潤訂單比例" :class="$style.profitSlider">
            <div>
              <el-input-number v-model="submitData.commission_value" precision="0" :min="0" :max="100" />
              <el-slider v-model="submitData.commission_value" />
            </div>
          </el-form-item>
        </template>
      </el-form>
      <template v-if="submitData.commission_type === '%'">
        <div style="margin-bottom: 30px;"> <span v-if="submitData.commission_type === '%'">&asymp;</span>NT${{ estimatePrice }} </div>
      </template>
      <el-button type="primary" class="is-round" :class="$style.btn" @click="saveProfitSharing">
        確定
      </el-button>
      <el-button class="is-round" :class="$style.btn" @click="closeDialog">
        取消
      </el-button>
    </el-dialog>
  </div>
</template>

<script>
import lazyLoadComponent from '@router/lazyload-component'
export default {
  name: 'ProfitSharing',
  components: {
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
  },
  mixins: [],
  props: {
    /**
     * @description 此次訂單的order-type
     */
    orderType: {
      type: String,
      default: '',
      required: true,
    },
    /**
     * @description 此次開啟的訂單內容
     */
    orderInfo: {
      type: Object,
      default: () => {
        return {}
      },
    },
  },
  data() {
    return {
      addProfileSharingDialog: false, // 業績分潤人員視窗
      submitData: {
        id: '',
        product_id: '',
        order_id: '',
        schedule_item_id: '',
        commission_type: 'fixed',
        commission_value: 0,
      },
      scheduleItemList: [], // 人員列表
      productList: [], // 分店列表
    }
  },
  provide() {},
  inject: [],
  computed: {
    /**
     * @description 約略的分潤金額
     */
    estimatePrice() {
      if (this.submitData.commission_type === 'fixed') {
        return this.submitData.commission_value
      }
      if (this.submitData.commission_type === '%') {
        let value = +this.orderInfo.priceTotal * (this.submitData.commission_value / 100)
        return Math.floor(value)
      }
      return 0
    },
    /**
     * @description 儲存分潤的id
     */
    storeId() {
      if (this.orderType === 'prepaid') {
        return this.orderInfo.id
      }
      if (this.orderType === 'deposit') {
        return this.orderInfo.containerInfo.displayId
      }
      return ''
    },
    /**
     * @description 依分店過濾人員名單
     */
    filterScheduleItemList() {
      if (this.submitData.product_id.length > 0) {
        let result = this.scheduleItemList.reduce((accu, cur) => {
          if (cur.storeIds.includes(this.submitData.product_id)) {
            accu.push(cur)
          }
          return accu
        }, [])
        return result
      }
      return this.scheduleItemList
    },
    /**
     * @description 分潤人員列表
     */
    commissionPersonList() {
      if (this.orderType === 'prepaid' && 'commissionDetails' in this.orderInfo) {
        const { items } = this.orderInfo.commissionDetails
        const nameList = items.reduce((accu, cur) => {
          if (cur.commission_category === 'performance') {
            accu.push({
              name: this.findScheduleItemName(cur.schedule_item_id),
              price: cur.commission_type === 'fixed' ? +cur.commission_value : +cur.item_price * (cur.commission_value / 100),
              id: cur.id,
            })
          }
          return accu
        }, [])
        return nameList
      }
      if (this.orderType === 'deposit' && 'containerInfo' in this.orderInfo) {
        const { items } = this.orderInfo.containerInfo.commissionDetails
        const nameList = items.reduce((accu, cur) => {
          if (cur.commission_category === 'performance') {
            accu.push({
              name: this.findScheduleItemName(cur.schedule_item_id),
              price: cur.commission_type === 'fixed' ? +cur.commission_value : +cur.item_price * (+cur.commission_value / 100),
              id: cur.id,
            })
          }
          return accu
        }, [])
        return nameList
      }
      return [
        {
          name: '',
          price: 0,
        },
      ]
    },
  },
  watch: {
    'submitData.product_id': {
      handler(nvl, ovl) {
        this.submitData.schedule_item_id = ''
      },
    },
  },
  async mounted() {
    await this.fetchScheduleItem()
    await this.tryToFetchProduct()
  },
  methods: {
    /**
     * @description 刪除人員
     */
    async handleRemove(scheduleItem) {
      try {
        await this.$store.dispatch('commission/removeCommission', {
          ids: [scheduleItem.id],
        })
        this.$emit('updateOrder')
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 找到人員名稱
     */
    findScheduleItemName(id) {
      const scheduleItemObj = this.scheduleItemList.find((item) => item.id === id)
      if (scheduleItemObj) {
        return scheduleItemObj.name
      } else {
        return ''
      }
    },
    /**
     * @description 儲存分潤人員
     */
    async saveProfitSharing() {
      try {
        await this.validateSubmitData()
        await this.$store.dispatch('commission/addEditCommission', this.submitData)
        this.$emit('updateOrder')
        this.addProfileSharingDialog = false
        this.resetSubmitData()
      } catch (error) {
        console.error(error.message)
      }
    },
    /**
     * @description 清空submitData
     */
    resetSubmitData() {
      this.$set(this.submitData, 'id', '')
      this.$set(this.submitData, 'product_id', '')
      this.$set(this.submitData, 'order_id', '')
      this.$set(this.submitData, 'schedule_item_id', '')
      this.$set(this.submitData, 'commission_type', 'fixed')
      this.$set(this.submitData, 'commission_value', 0)
    },
    /**
     * @description 驗證儲存資料
     */
    async validateSubmitData() {
      return new Promise((resolve, reject) => {
        if (this.storeId.length === 0) {
          reject(new Error('請確認訂單編號'))
        }
        // 都通過了就開始設定資料
        this.$set(this.submitData, 'order_id', this.storeId)
        resolve()
      })
    },
    /**
     * @description 獲取所有分店
     */
    async tryToFetchProduct() {
      const { items } = await this.$store.dispatch('product/fetchList', {
        limit: 10000,
        page: 1,
        paginate: 0,
      })
      this.productList = items
    },
    /**
     * @description 獲取人員下拉
     */
    async fetchScheduleItem() {
      const result = await this.$store.dispatch('schedule/fetchStaff', {
        paginate: 0,
        type: 'cosmetic',
      })
      this.scheduleItemList = result
    },
    /**
     * @description 關閉dialog
     */
    closeDialog() {
      this.addProfileSharingDialog = false
      this.resetSubmitData()
    },
    /**
     * @description 開啟新增業績分潤人員視窗
     */
    openAddProfileSharingDialog() {
      this.addProfileSharingDialog = true
    },
    /**
     * @description 視窗關閉
     */
    handleClose() {
      this.addProfileSharingDialog = false
    },
    handleInput() {
      const { commission_value } = this.submitData
      const maxValue = this.orderInfo.priceTotal
      const isAllZeros = /^0+$/.test(String(commission_value))

      if (isAllZeros) {
        this.submitData.commission_value = 0
        return
      }
      if (commission_value > maxValue) {
        this.submitData.commission_value = maxValue
      }
      if (commission_value < 0) {
        this.submitData.commission_value = 0
      }
    },
  },
}
</script>

<style lang="scss" module>
.profitSharing {
  :global {
    .addBtn {
      height: 88px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 14px;
      border: 1px dashed #f4f4f4;
    }
  }
}

.profitSlider {
  :global {
    .el-form-item__label {
      float: none;
    }

    .el-input-number {
      width: 100%;
      line-height: 42px;
    }

    .el-input-number__increase {
      border-radius: $border-radius;
    }

    .el-input-number__decrease {
      border-radius: $border-radius;
    }

    .el-slider {
      margin-top: 10px;
    }
  }
}

.btn {
  width: 100%;
  margin-left: 0 !important;
  margin-bottom: 10px;
}

.commissionPersonDisplay {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #f4f4f4;

  :global {
    .personPrice {
      display: flex;
      flex-direction: column;
      justify-content: flex-start;
      align-items: flex-start;
    }

    .mainText {
      color: $color-secondary;
    }
  }
}

.mainColor {
  color: $color-primary;
}
</style>
